import { useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import {
  ManageClients,
  DeleteClients,
  EditClients,
  SearchClients,
} from "./actions";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import { GetClients } from "./actions";
import { useNavigate } from "react-router-dom";

const Clients = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const Commonalert = CommonAlert();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState([]);

  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);

  const Schema = Yup.object().shape({
    first_name: Yup.string().trim().required("required"),
    last_name: Yup.string().trim().required("required"),
    email: Yup.string().trim().required("required").email("enter valid email"),
    password: editMode
      ? Yup.string().trim()
      : Yup.string().trim().required("required"),
  });

  const GetData = () => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetClients({
        page,
        rowsPerPage,
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setData(data?.data);
            setMeta(data?.meta);
          } else {
            setData([]);
          }
          if (array.length == 0) {
            setarray([
              {
                failed: "id",
                type: inputType.text,
                title: "id",
                placeholder: "",
                fullwidth: true,
                customdesign: { display: "none" },
              },
              {
                failed: "first_name",
                type: inputType.text,
                title: "First Name",
                placeholder: "",
                fullwidth: true,
              },
              {
                failed: "last_name",
                type: inputType.text,
                title: "Last Name",
                placeholder: "",
                fullwidth: true,
              },
              {
                failed: "email",
                type: inputType.text,
                title: "Email",
                placeholder: "",
                fullwidth: true,
              },
              {
                failed: "password",
                type: inputType.text,
                title: "Password",
                placeholder: "",
                fullwidth: true,
              },
              {
                failed: "image",
                type: inputType.image,
                title: "Image",
                placeholder: "",
                fullwidth: true,
              },
            ]);
          }
          setLoadingData(false);
        },
      })
    );
  };

  useEffect(() => {
    GetData({ tableName: null, type: null });
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "first_name" },
    { type: columntype.text, name: "last_name" },
    { type: columntype.image, name: "image" },
    { type: columntype.text, name: "email" },
    { type: columntype.switch, name: "is_active" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "id",
      withSort: true,
    },
    {
      id: "first_name",
      numeric: false,
      disablePadding: false,
      label: "First Name",
      withSort: false,
    },
    {
      id: "last_name",
      numeric: false,
      disablePadding: false,
      label: "Last Name",
      withSort: false,
    },
    {
      id: "image",
      numeric: false,
      disablePadding: false,
      label: "Image",
      withSort: false,
    },
    {
      id: "email",
      numeric: false,
      disablePadding: false,
      label: "Email",
      withSort: false,
    },
    {
      id: "is_active",
      numeric: false,
      disablePadding: false,
      label: "Is active",
      withSort: true,
    },
    (dataPrivileges["3"]?.access_edit == 1 ||
      dataPrivileges["3"]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      withSort: false,
    },
  ];

  const List = [
    dataPrivileges["3"]?.access_delete == 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Are you sure to delete ${row?.username ?? ""}?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteClients({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      id: [row.id],
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    dataPrivileges["3"]?.access_edit == 1 && {
      name: "Edit",
      function: async (data) => {
        setEditMode(true);
        setvalues(data);
        setShowModal(true);
      },
    },
    dataPrivileges["23"]?.access_read == 1 && {
      name: "View AI Chat Sessions",
      function: async (data) => {
        navigate(`/user-ai-chat-sessions/${data?.id}`);
      },
    },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditClients({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
        },
      })
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => {
      return prevData.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [failedName]: newData,
          };
        }
        return item;
      });
    });
    setloadingEditdatatype("");
  };

  const debounceRef = useRef(null);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearch(value);

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      if (value === "" || !value) {
        return;
      }

      dispatch(
        SearchClients({
          search: value, // Use latest value directly
          callback: (data) => {
            console.log({ data123123: data });
            if (data) {
              setData(data?.data);
            }
          },
        })
      );
    }, 1000);
  };

  return (
    <>
      <DynamicTable
        handleSearch={handleSearch} // call api
        onRequestSort={(tableName, type) => {
          if (tableName && type) {
            GetData({ tableName, type });
          }
        }} // call api
        onPressDelete={(ListIds) => {
          Commonalert.show({
            title: "Are you sure?",
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteClients({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      id: ListIds,
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }} // call api
        onPressItem={(row) => {}} // when press item
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }} // when press checkbox or switch
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }} // when press add new button show modal to add new item
        items={data} // all data
        columns={columns} // type of data
        headCells={headCells} // columns name
        page={page} // number of page from api
        setPage={setPage} // set number of page from api
        selected={selected} // selected items
        setSelected={setSelected} // set selected items
        search={search} // search failed
        rowsPerPage={rowsPerPage} // number show Data
        setRowsPerPage={setRowsPerPage} // set number show data
        Listdropdown={List} // list action with function
        withOption={true} // for remove action column
        loadingData={loadingData} // when load data from api
        rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
        totalItem={meta?.total} // total data without pagination
        loadingEditdatatype={loadingEditdatatype} // first failed (id) and second (failed Name) like ={"1-is_active"}
        withAddButton={dataPrivileges["3"]?.access_write == 1 ? true : false}
        withDeleteItem={dataPrivileges["3"]?.access_delete == 1 ? true : false}
        withEditItem={dataPrivileges["3"]?.access_edit == 1 ? true : false}
        withPagination={true}
        withSearch={true}
        nameTable={`Clients`}
      />
      {showModal ? (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Client"}
          editMode={editMode}
          description={editMode ? "Edit" : "Add new client"}
          buttonTitle={editMode ? "Edit" : "Add"}
          onSubmit={(valuess) => {
            console.log({ valuess123323: valuess });
            dispatch(
              ManageClients({
                editMode: editMode,
                values: valuess,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData({ tableName: null, type: null });
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      ) : null}
    </>
  );
};

export default Clients;
